import { render, staticRenderFns } from "./FeaturesWidget.vue?vue&type=template&id=70503a3b&"
import script from "./FeaturesWidget.vue?vue&type=script&lang=js&"
export * from "./FeaturesWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/pp-weberbuero/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70503a3b')) {
      api.createRecord('70503a3b', component.options)
    } else {
      api.reload('70503a3b', component.options)
    }
    module.hot.accept("./FeaturesWidget.vue?vue&type=template&id=70503a3b&", function () {
      api.rerender('70503a3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/FeaturesWidget.vue"
export default component.exports